import { Component, Input } from '@angular/core';
import { COMMON_MODULES } from '@src/app/core/constants';

@Component({
  selector: 'app-mini-env-tall-info-card',
  imports: [...COMMON_MODULES],
  templateUrl: './mini-env-tall-info-card.component.html',
  styleUrl: './mini-env-tall-info-card.component.scss'
})
export class MiniEnvTallInfoCardComponent {
  @Input() title: any;
  @Input() description: any;
  @Input() style: any;
  @Input() bgImage: any;
}
